import { createWebHistory, createRouter } from 'vue-router'
import { useGlobalStore } from '@stores/global'

/* Layouts */
import App from '@layouts/App.vue'

/* Pages */
import Index from '@pages/Index.vue'
import Host from '@pages/Host.vue'
import Event from '@pages/Event.vue'
import Events from '@pages/Events.vue'
import Tournament from '@pages/Tournament.vue'
import Galleries from '@pages/Galleries.vue'
import Media from '@pages/Media.vue'
import News from '@pages/News.vue'
import Article from '@pages/Article.vue'
import PointsRanking from '@pages/PointsRanking.vue'

/* Routes */
const routes = [
	{
		path: '/',
		component: App,
		children: [
			{ path: '', name: 'index', component: Index },
			// { path: 'host', name: 'host', component: Host },
			{ path: 'tournament/:slug', name: 'tournament', component: Tournament },
			// { path: 'event/:slug', name: 'event', component: Event },
			{ path: 'events', name: 'events', component: Events },
			{ path: 'points-ranking', name: 'points-ranking', component: PointsRanking },
			{ path: 'media-gallery', name: 'galleries', component: Galleries },
			{ path: 'media/:slug?', name: 'media', component: Media },
			{ path: 'news', name: 'news', component: News },
			{ path: 'article/:slug?', name: 'article', component: Article },
			{
				path: '/leaderboard',
				name: 'leaderboard',
				redirect: { name: 'points-ranking' },
			},
			{
				path: '/leaderboards',
				name: 'leaderboards',
				redirect: { name: 'points-ranking' },
			},
			{
				path: '/:catchAll(.*)',
				name: '404',
				redirect: { name: 'index' },
			},
		],
	},
]

const router = createRouter({
	scrollBehavior(to, from, savedPosition) {
		if (to.name == from.name && !to.hash) {
			return { top: 0, behavior: 'smooth' }
		} else if (to.hash) {
			return {
				el: to.hash,
				top: 100,
				behavior: 'smooth',
			}
		} else {
			return {
				top: 0,
			}
		}
	},
	history: createWebHistory(),
	routes,
})

router.beforeEach((to, from, next) => {
	const global = useGlobalStore()
	global.closeModal()
	next()
})

export default router
